import React, { useEffect, useState } from 'react';

import { useMsal } from "@azure/msal-react";
import { useNavigate } from 'react-router-dom';
import { getPlasticData } from '../../api/auth';
import Navbar from '../../component/NavBar';
import Header from '../../component/Header';
import Spinner from '../../component/Spinner';

function PlasticMonitoring() {

    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();

    const navigate = useNavigate();

    const [isShow, setIsShow] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [date, setDate] = useState('');
    const [plasticData, setPlasticData] = useState([]);

    useEffect(() => {
        if (!activeAccount) {
            navigate("/mes");
        }
    }, [activeAccount]);

    useEffect(() => {
        (async () => {
            try {
                setIsShow(true);
                const result = await getPlasticData();
                console.log('result', result);
                if (result.ok === true) {
                    setDate(result.date);
                    setPlasticData(result.data);
                } else {
                    alert("API CALL FAIL");
                }
            } catch (error) {
                console.log('error', error);
                alert(error.message);
            } finally {
                setIsShow(false);
            }
        })();
    }, [refresh]);

    return (
        <>
            <Spinner isShow={isShow} />
            <Header setRefresh={setRefresh} />
            <Navbar />
            <div className='p-1'>
                <div className='font-bold'>
                    HMMA Sequence - <span className='uppercase'>{date}</span>
                </div>
                <div className="relative overflow-x-auto">
                    <table className="w-full text-md text-center rtl:text-right text-gray-500 ">
                        <thead className="text-xs text-gray-700 uppercase bg-slate-300  ">
                            <tr>
                                <th scope="col" className="py-1">

                                </th>
                                <th scope="col" className="py-1">
                                    SEQ
                                </th>
                                <th scope="col" className="py-1">
                                    TIME
                                </th>
                                <th scope="col" className="py-1">
                                    CTS
                                </th>
                            </tr>
                        </thead>
                        <tbody className="text-black">
                            {
                                plasticData?.output?.ASSY?.map((v, i) => {
                                    return i == 0 ? (
                                        <tr key={i} className={`${i % 2 === 0 ? 'bg-white' : 'bg-gray-100'} border-b `}>
                                            <td className="py-1">
                                                P39
                                            </td>
                                            <td className="py-1">
                                                {v.HMMA_SEQ}
                                            </td>
                                            <td className="py-1">
                                                {v.HMMA_TIME.substring(8, 10) + ':' + v.HMMA_TIME.substring(10, 12) + ':' + v.HMMA_TIME.substring(12, 14)}
                                            </td>
                                            <td className="py-1">
                                                {plasticData?.output?.CTS}
                                            </td>
                                        </tr>
                                    ) : null
                                })
                            }
                        </tbody>
                    </table>
                </div>
                <div className='font-bold mt-3'>
                    HMMA Assembly Shop
                </div>
                <div className="relative overflow-x-auto">
                    <table className="w-full text-md text-center rtl:text-right text-gray-500 ">
                        <thead className="text-xs text-gray-700 uppercase bg-slate-300  ">
                            <tr>
                                <th scope="col" className="py-1">
                                    LINE
                                </th>
                                <th scope="col" className="py-1">
                                    QUEUE
                                </th>
                                <th scope="col" className="py-1">
                                    LOAD
                                </th>
                                <th scope="col" className="py-1">
                                    SHIP
                                </th>
                                <th scope="col" className="py-1">
                                    PF
                                </th>
                            </tr>
                        </thead>
                        <tbody className="text-black">
                            {
                                plasticData?.output?.ASSY?.map((v, i) => {
                                    return (
                                        <tr key={i} className={`${i % 2 === 0 ? 'bg-white' : 'bg-gray-100'} border-b `}>
                                            <td className="py-1">
                                                <span className={`${v.MITU_STAT === 'R' ? 'text-red-600' : v.MITU_STAT === 'G' ? 'text-green-500' : 'text-black'} font-extrabold`}>
                                                    O
                                                </span>
                                                <span> </span>{v.LINE}
                                            </td>
                                            <td className="py-1">
                                                {v.MITU}
                                            </td>
                                            <td className="py-1">
                                                {v.LOAD_INP}
                                            </td>
                                            <td className="py-1">
                                                {v.SHIP}
                                            </td>
                                            <td className="py-1">
                                                {v.UTIL}%
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
                <div className='font-bold mt-3'>
                    <a href="/mes/rtms" target="_blank" className='underline font-bold text-blue-900'>HMMA Shipping Status</a>
                </div>
                <div className="relative overflow-x-auto">
                    <table className="w-full text-md text-center rtl:text-right text-gray-500 ">
                        <thead className="text-xs text-gray-700 uppercase bg-slate-300  ">
                            <tr>
                                <th scope="col" className="py-1">
                                    LINE
                                </th>
                                <th scope="col" className="py-1">
                                    FLOOR
                                </th>
                                <th scope="col" className="py-1">
                                    TRUCK
                                </th>
                                <th scope="col" className="py-1">
                                    TIME
                                </th>
                                <th scope="col" className="py-1">
                                    HMMA
                                </th>
                            </tr>
                        </thead>
                        <tbody className="text-black">
                            {
                                plasticData?.output?.ASSY?.map((v, i) => {
                                    let time;
                                    if (v.TRUCK_NO.indexOf('-') > -1) {
                                        time = v.TRUCK_NO.substring(v.TRUCK_NO.indexOf('-') + 1);
                                    } else {
                                        time = '-';
                                    }
                                    return (
                                        <tr key={i} className={`${i % 2 === 0 ? 'bg-white' : 'bg-gray-100'} border-b `}>
                                            <td className="py-1">
                                                <span className={`${v.H_INV_STAT === 'Y' ? 'text-yellow-300' : v.H_INV_STAT === 'R' ? 'text-red-500' : 'text-green-500'} font-extrabold`}>
                                                    O
                                                </span>
                                                <span> </span>{v.LINE}
                                            </td>
                                            <td className="py-1">
                                                {v.FLOOR_CNT}
                                            </td>
                                            <td className="py-1">
                                                {v.INTRANSIT_CNT}
                                            </td>
                                            <td className="py-1">
                                                {time}
                                            </td>
                                            <td className="py-1">
                                                {v.H_INV}
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
                <div className="relative overflow-x-auto">
                    <table className="w-full text-md text-center rtl:text-right text-gray-500 ">
                        <thead className="text-xs text-gray-700 uppercase bg-slate-300  ">
                            <tr>
                                <th scope="col" colSpan={5} className="py-1">
                                    BUMPER SHIPPING HISTORY
                                </th>
                            </tr>
                            <tr>
                                <th scope="col" className="py-1">
                                    LINE
                                </th>
                                <th scope="col" className="py-1">
                                    SEQ
                                </th>
                                <th scope="col" className="py-1">
                                    TRUCK
                                </th>
                                <th scope="col" className="py-1">
                                    QTY
                                </th>
                                <th scope="col" className="py-1">
                                    DIV.TM
                                </th>
                            </tr>
                        </thead>
                        <tbody className="text-black">
                            {
                                plasticData?.rtms?.output?.TruckHistory?.map((v, i) => {
                                    return (
                                        <tr key={i} className={`${i % 2 === 0 ? 'bg-white' : 'bg-gray-100'} border-b `}>
                                            <td className="py-1">
                                                {v.EQCODE === "2BF01" ? "Front" :
                                                    v.EQCODE === "2BR01" ? "Rear" :
                                                        v.EQCODE}
                                            </td>
                                            <td className="py-1">
                                                {v.SEQ}
                                            </td>
                                            <td className="py-1">
                                                {v.TRUCK_NO}
                                            </td>
                                            <td className="py-1">
                                                {v.SHIP_QTY}
                                            </td>
                                            <td className="py-1">
                                                {v.DLV_TIME}
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
                <div className='font-bold mt-3'>
                    Georgia Shipping Status
                </div>
                <div className="relative overflow-x-auto">
                    <table className="w-full text-md text-center rtl:text-right text-gray-500 ">
                        <thead className="text-xs text-gray-700 uppercase bg-slate-300  ">
                            <tr>
                                <th scope="col" className="py-1">
                                    PRT.TM
                                </th>
                                <th scope="col" className="py-1">
                                    SHP.TM
                                </th>
                                <th scope="col" className="py-1">
                                    TRUCK
                                </th>
                                <th scope="col" className="py-1">
                                    LOAD#
                                </th>
                            </tr>
                        </thead>
                        <tbody className="text-black">
                            {
                                plasticData?.output?.GASHIP?.map((v, i) => {
                                    return (
                                        <tr key={i} className={`${i % 2 === 0 ? 'bg-white' : 'bg-gray-100'} border-b `}>
                                            <td className="py-1">
                                                {v.CARDEPDT} {v.CARDEPTM}
                                            </td>
                                            <td className="py-1">
                                                {v.CARDEPDT} {v.CARDEPTM}
                                            </td>
                                            <td className="py-1">
                                                <a href={`/mes/GAShipItem?plant=${v.PLANT}&ifkdt=${v.IFKDT}&seqhd=${v.SEQHD}`}
                                                    target="_blank"
                                                    className='underline font-bold text-blue-900'>
                                                    {v.TRKNO}
                                                </a>
                                            </td>
                                            <td className="py-1">
                                                {v.LOADNO}
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
                <div className='font-bold mt-3'>
                    Paint Shop (Util-
                    PT#1: {plasticData?.output?.PT?.filter(v => v.MODEL === '2PT01')?.[0]?.UTIL ?? 'null'}%
                    PT#2: {plasticData?.output?.PT?.filter(v => v.MODEL === '2PT21')?.[0]?.UTIL ?? 'null'}%
                    )
                </div>
                <div className="relative overflow-x-auto">
                    <table className="w-full text-md text-center rtl:text-right text-gray-500 ">
                        <thead className="text-xs text-gray-700 uppercase bg-slate-300  ">
                            <tr>
                                <th scope="col" className="py-1">
                                    MODEL
                                </th>
                                <th scope="col" className="py-1">
                                    OUT
                                </th>
                                <th scope="col" className="py-1">
                                    GOOD
                                </th>
                                <th scope="col" className="py-1">
                                    RATE
                                </th>
                                <th scope="col" className="py-1">
                                    RTN
                                </th>
                            </tr>
                        </thead>
                        <tbody className="text-black">
                            {
                                plasticData?.output?.PT?.map((v, i) => {
                                    let model = v.MODEL?.substring(0, 2) + v.PROD_TYPE?.replaceAll("BMPF", "BF").replaceAll("BMPR", "BR");
                                    if (v.MODEL === '2PT01') {
                                        model = 'H.SUM';
                                    } else if (v.MODEL === '2PT21') {
                                        model = 'K.SUM';
                                    }
                                    return (
                                        <tr key={i} className={`${['2PT01', '2PT21'].includes(v.MODEL) ? 'bg-yellow-200' : 'bg-white'} border-b `}>
                                            <td className="py-1">
                                                {v.LASTCOLOR === '1' ? <span className='text-green-500 font-extrabold'>O</span> : ''}
                                                {model}
                                            </td>
                                            <td className="py-1">
                                                {v.SUM_QTY}
                                            </td>
                                            <td className="py-1">
                                                {v.GOOD_QTY}
                                            </td>
                                            <td className="py-1">
                                                {v.RATE1}
                                            </td>
                                            <td className="py-1">
                                                {v.FNS_QTY}
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
                <div className='font-bold mt-3'>
                    Molding Shop
                </div>
                <div className="relative overflow-x-auto">
                    <table className="w-full text-md text-center rtl:text-right text-gray-500 ">
                        <thead className="text-xs text-gray-700 uppercase bg-slate-300  ">
                            <tr>
                                <th scope="col" className="py-1">
                                    IMM No
                                </th>
                                <th scope="col" className="py-1">
                                    Part
                                </th>
                                <th scope="col" className="py-1">
                                    Qty
                                </th>
                            </tr>
                        </thead>
                        <tbody className="text-black">
                            {
                                plasticData?.output?.MD?.map((v, i) => {
                                    const immNo = v.IMM_no?.replaceAll("2PR", "");
                                    let part = v.Part ?? "";

                                    if (part === "") {
                                        part = '-'
                                    } else if (part?.length > 10) {
                                        part = part.substring(0, 9);
                                    }

                                    return (
                                        <tr key={i} className={`${i % 2 === 0 ? 'bg-white' : 'bg-gray-100'} border-b `}>
                                            <td className="py-1">
                                                <span className={`${v.Stat === 'G' ? 'text-green-500' : v.Stat === 'R' ? 'text-red-500' : 'text-yellow-300'} font-extrabold`}>
                                                    O
                                                </span>
                                                <span> </span>{immNo}
                                            </td>
                                            <td className="py-1">
                                                {part}
                                            </td>
                                            <td className="py-1">
                                                {v.qty}
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default PlasticMonitoring;
